import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-connect-email-account',
  templateUrl: './connect-email-account.component.html',
  styleUrls: ['./connect-email-account.component.scss']
})
export class ConnectEmailAccountComponent {

  @Output() close = new EventEmitter<void>();
  showOutlook: boolean = false;
  showDomainAuth: boolean = false;

  constructor(private router: Router,
    private modalService: NgbModal,
    private localStorage: LocalStorageService
  ) { }

  ngOnInit() {
    let permissions = this.localStorage.getPermissions();

    // ✅ Ensure permissions is an array
    if (typeof permissions === 'string') {
      permissions = JSON.parse(permissions);
    }

    const hasMailHub = permissions?.some((module: any) =>
      module.module_name === 'sales-mail-hub' && module.active
    );

    const hasDomainAuth = permissions?.some((module: any) =>
      module.module_name === 'setting' &&
      module.features?.some((f: any) => f.name === 'domain_authentication' && f.active)
    );

    this.showOutlook = hasMailHub;
    this.showDomainAuth = hasDomainAuth;

    if(this.showOutlook && this.showDomainAuth) {
      this.showOutlook = true;
      this.showDomainAuth = false;
    }

  }


  redirectToOutlook() {
    this.modalService.dismissAll();
    this.router.navigate(['/main/sales-mail-hub']);
  }

  redirectToDomainAuth() {
    this.modalService.dismissAll();
    this.router.navigate(['/main/domain-authentication']);
  }

  closeModal() {
    this.close.emit();
  }
}
